// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3qxr6","itemTitle":"ClientEmergencyInfo_itemTitle__2Xf-x","itemText":"ClientEmergencyInfo_itemText__1Rwzj"};